import React, { useEffect } from 'react';
import './App.css';
import Header from './Components/Header';
import Home from './Components/Home';
import LogIn from './Components/Login';
import Checkout from './Components/Basket';
import Payment from './Components/Payment';
import Orders from './Components/Orders';
import { auth } from './firebase';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { SetActiveUser, diactiveUser } from './Redux/ActionCreator';
import { connect } from 'react-redux';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

const promise = loadStripe(
  'pk_test_51HeUEID2DO9zZJwtdHt3p1303nJX4GIpnETTeR4X9G5QOVUFrQPT6nxFTz0TQbAyLezhMNZtVBCC5fnSlOpSF9VZ00nKIJW3uA'
);
const mapDispatchToProps = (dispatch) => ({
  SetActiveUser: (user) => dispatch(SetActiveUser(user)),
  diactiveUser: (user) => dispatch(diactiveUser()),
});

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};
//-----------------------------------------------------------------------------------//
///----------------------App Class Component Definition ----------------------------//
//----------------------------------------------------------------------------------//

function App(props) {
  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      console.log('the user ', authUser);
      if (authUser) {
        //------------------- the user just logged in ------------//
        props.SetActiveUser(authUser);
      } else {
        props.diactiveUser();
        // ---------------- the user LoggedOut -------------------//
      }
    });
  });

  console.log(props.user);
  return (
    <Router>
      <div className="app">
        <Switch>
          <Route exact path="/Login">
            <LogIn />
          </Route>
          <Route exact path="/orders">
            <Header />
            <Orders />
          </Route>
          <Route exact path="/paymentPage">
            <Header />
            <Elements stripe={promise}>
              <Payment />
            </Elements>
          </Route>
          <Route exact path="/checkout">
            <Header />
            <Checkout />
          </Route>
          <Route exact path="/">
            <Header />
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
